import { createContext } from 'react';

const HabitatsState = createContext();

export default HabitatsState;
